import BaseMapper from './base';
import { CardLightProps, Component } from '../types';

enum TextLanguageFieldsEnum {
  lightTitle = 'lightTitle',
  boldTitle = 'boldTitle',
  text = 'text',
  icon = 'icon',
  url = 'url',
}

type TextLanguageFields = `${TextLanguageFieldsEnum}`;

class ModuleCardLight extends BaseMapper {
  public async generateComponent(): Promise<Component<CardLightProps>> {
    const props = this.getProps();

    return {
      name: 'CardLight',
      props,
    };
  }

  private getProps(): CardLightProps {
    const props = {} as CardLightProps;

    Object.assign(
      props,
      this.mapTextLanguageFields<Pick<CardLightProps, TextLanguageFields>>({
        fieldsToMap: [
          { key: 'module_card_special_title', mappedKey: 'lightTitle' },
          { key: 'module_card_vertical_pill_text', mappedKey: 'text' },
          { key: 'module_card_light_url', mappedKey: 'url' },
        ],
      }),
    );

    props.icon = this.mapContentField<string>({
      contentKey: 'module_card_light_image',
      defaultValue: '',
    });

    return props;
  }
}

export default ModuleCardLight;
